import { render, staticRenderFns } from "./VDCardItem.vue?vue&type=template&id=599bf17c&scoped=true"
import script from "./VDCardItem.vue?vue&type=script&lang=ts"
export * from "./VDCardItem.vue?vue&type=script&lang=ts"
import style0 from "./VDCardItem.vue?vue&type=style&index=0&id=599bf17c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599bf17c",
  null
  
)

export default component.exports